export enum OrderStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2
}